// src/app/adressizKatmanGeri.ts
//
// ─── ADRESSİZ KATMAN → GERİ TUŞU (saf karar katmanı) ─────────────────────────
//
// ── NİYE VAR (ölçüm, varsayım değil) ────────────────────────────────────────
// Bazı katmanların PAYLAŞILABİLİR ADRESİ OLAMAZ ama yine de geri tuşuna cevap
// vermek ZORUNDADIR. İki tanesi bu turda ölçüldü:
//
//   1. `ProfileView` (mlv3) aksiyon sheet'i — `setActionsOpen(true)` düz
//      state'ti, history girdisi YOKTU. Donanım geri tuşu sheet'i kapatmak
//      yerine ALTTAKİ katmanı (profil overlay'i) tüketiyordu. Aynı sheet'in
//      ikizi `ProfileMobile`da girdiyi ZATEN pushluyor (satır ~737) — yani
//      iki yüzey arasında parite KIRIKTI.
//   2. Kart REVEAL (kutu açılış) koreografisi — `_reveal:true`. Adresi
//      #863'te BİLEREK verilmedi (tek seferlik sunucu sonucu; yenilenemez,
//      paylaşılamaz) ve o karar testle kilitli. Ama adressiz olması, geri
//      tuşunun kullanıcıyı PROFİLDEN ATMASINI meşru kılmıyordu.
//
// ── DÜNYA ÖRNEĞİ (kaynak gösterilen gerekçe) ────────────────────────────────
// "Modal = history entry" mobil web'in yerleşik desenidir: Instagram'ın
// story/reels açılışı, kebab menüleri ve paylaşım sayfaları Android donanım
// geri tuşunda SAYFAYI değil ÜSTTEKİ KATMANI kapatır. Aynı desen bu repoda da
// üç yerde bağımsız olarak yeniden keşfedilmiş durumda:
//   · `components/BottomSheet.tsx`      → `pushState({__bsheet:true}, "")`
//   · `myclipsv3/profile/EditProfileSheet.tsx` → `pushState({sheet:TAG}, "", href)`
//   · `ProfileMobile.tsx` aksiyon sheet'i     → `pushState({sheet:"profile-actions"}, "", href)`
// Üçünün de ORTAK yanı: **URL DEĞİŞMEZ** (`location.href` aynen geri verilir),
// yalnız yığına bir girdi konur. Adres çubuğu hiçbir şey iddia etmez; geri
// tuşu yine de katmanı kapatır. Bu dosya o üç kopyanın KARAR kısmıdır.
//
// ── NİYE URL VERİLMİYOR (bilinçli karar, eksiklik değil) ────────────────────
// · Aksiyon sheet'i: içeriği İZLEYENE göre değişir (self menüsü ≠ karşı taraf
//   menüsü; engelli/sessize alınmış durumları). `/{u}/actions` gibi bir adres
//   paylaşıldığında alıcıya BAŞKA bir menü açardı — yani YALAN SÖYLEYEN bir
//   adres olurdu. Geçici bir bağlam menüsünün cold-load'u da anlamsızdır.
// · Reveal: #863'ün kilitli kararı (`useKartDetayKatmani` yorumu + testi).
// Kanon kütüğü kuralı da bunu destekler: `ROUTER_MODAL_KATMANLARI`ya YALNIZ
// `setModalContent(katman(...))` ile üretilen ROUTER modalları yazılır. Bu iki
// katman profilin YEREL state'i (emsal: `EditClipSheet`, #863 kart katmanı) →
// kütüğe yazılmaz.
//
// ── NİYE SAF + AYRI DOSYA ───────────────────────────────────────────────────
// `ProfileView` (2400+ satır, Firestore + medya bağımlı) içine gömülü bir
// karar ancak "kaynak metinde şu dizge var mı" ile ölçülebilirdi.
// (`kartDetayUrl.ts` / `haritaMekanUrl.ts` ile birebir aynı gerekçe.)

/** History state'ine konan damga — pop'ta girdinin BİZİM olduğunu söyler. */
export const ADRESSIZ_KATMAN_ANAHTARI = "__adressizKatman";

/** Bu turda kullanılan etiketler — iki katman aynı damgayı paylaşmasın. */
export const ADRESSIZ_ETIKET = {
  /** mlv3 profil aksiyon sheet'i (ProfileMobile'daki "profile-actions" ikizi). */
  profilAksiyon: "mlv3-profil-aksiyon",
  /** Kutu açılış koreografisi (`_reveal:true`). */
  kartReveal: "kart-reveal",
  // ── MyClips V3 akış katmanları (2026-08-31 turu) ────────────────────────
  // ÖLÇÜLDÜ (`grep -c 'pushState(\|popstate'`): aşağıdaki beş katman ekranı
  // kaplıyor ama history'ye HİÇ dokunmuyordu — `EngagementRailV3.tsx` 0/0,
  // `MyClipsV3Gate.tsx` yalnız profil overlay'i için. Yani Android donanım
  // geri tuşu katmanı değil ALTTAKİ akışı tüketiyordu: kullanıcı yorumları
  // kapatmak isterken akıştan/uygulamadan çıkıyordu. Yukarıdaki 1. maddenin
  // (profil aksiyon sheet'i) birebir aynısı, beş yeni yüzeyde.
  /** Yorum sheet'i (`CommentSheetV3`). ÇAPALIYSA adresi de var → `useKlipYorumUrl`. */
  klipYorum: "mlv3-klip-yorum",
  /** Paylaş sheet'i (`DirectShareSheet`) — hedefler İZLEYENE özel, adres YOK. */
  klipPaylas: "mlv3-klip-paylas",
  /** Rail "Daha Fazla" sheet'i — geçici bağlam menüsü, adres YOK. */
  klipDahaFazla: "mlv3-klip-daha-fazla",
  /** "Koleksiyona kaydet" sheet'i — kullanıcının özel koleksiyonları, adres YOK. */
  klipKoleksiyon: "mlv3-klip-koleksiyon",
  /** mlv3 bildirim sheet'i (`NotificationSheet`) — içerik İZLEYENE özel, adres YOK. */
  bildirim: "mlv3-bildirim",
  // ── 2026-09-01 turu: gönderi yorum paneli + karşılama sihirbazı ─────────
  /**
   * `CommentsPanel` (gönderi/klip yorum sheet'i, `ProfilePostViewerMobile`in
   * üstünde). ÇAPASIZ açılır → paylaşılabilir adresi YOK, ama girdisi VAR.
   *
   * ⚠️ Burada geri tuşu yalnız "hiçbir şey yapmıyor" DEĞİLDİ: altındaki
   * `ProfilePostViewerMobile` `popstate`te `cleanupAndClose()` çağırıyor
   * (satır ~362), yani geri tuşu yorum panelini değil TÜM GÖRÜNTÜLEYİCİYİ
   * kapatıyordu — kullanıcı yorumları kapatmak isterken gönderiden çıkıyordu.
   * Kanca capture fazında `stopImmediatePropagation` attığı ve panel PPV'nin
   * ÇOCUĞU olduğu (React: çocuk effect'leri önce koşar → dinleyici önce
   * bağlanır) için pop artık o dinleyiciye ULAŞMAZ.
   */
  gonderiYorumPaneli: "gonderi-yorum-paneli",
  /**
   * `WelcomeWizard` — 5 adımlı TEK katman. Geri = ÖNCEKİ ADIM; ilk adımda
   * geri = sihirbazdan çık ama KALICI KAPATMA (localStorage "done" YAZILMAZ).
   * Girdi her adımda `girdiyiYenidenAl` ile tazelenir.
   */
  karsilamaSihirbazi: "karsilama-sihirbazi",
} as const;

export type AdressizKatmanDurumu = Record<string, unknown>;

/**
 * Push'lanacak history state'i.
 *
 * ⚠️ MEVCUT STATE **SPREAD EDİLİR** — ve bu, ölçülmüş bir tuzağın kapatılması:
 * `MyClipsV3Gate` popstate'te `state.mlv3 === "profile"` okuyup overlay'i AÇIK
 * tutuyor (`profileUidFromPopState`). State'i düşürseydik, bizim girdimize
 * gelen herhangi bir pop profili KAPANMIŞ sayardı. Aynı gerekçe
 * `useKartDetayUrl`ın push dalında da yazılı (EditClipSheet'te ölçülmüş).
 */
export function adressizKatmanDurumu(
  etiket: string,
  mevcut?: unknown,
): AdressizKatmanDurumu {
  const taban =
    mevcut && typeof mevcut === "object" ? (mevcut as AdressizKatmanDurumu) : {};
  return { ...taban, [ADRESSIZ_KATMAN_ANAHTARI]: etiket };
}

/** Yığının TEPESİ hâlâ bizim girdimiz mi? (state damgası okunur) */
export function adressizGirdimizTepede(durum: unknown, etiket: string): boolean {
  if (!durum || typeof durum !== "object") return false;
  return (durum as AdressizKatmanDurumu)[ADRESSIZ_KATMAN_ANAHTARI] === etiket;
}

/**
 * Katman KAPANDI (in-UI: X / scrim / satır seçimi) → kendi girdimizi
 * `history.back()` ile tüketelim mi?
 *
 * ── NİYE KOŞULLU ───────────────────────────────────────────────────────────
 * `false` dönen tek anlamlı hâl **DEVİR**: aksiyon sheet'i bir alt-sheet'e
 * zincirlendiğinde (`setActionsOpen(false); setEditOpen(true);`) çocuk
 * `EditProfileSheet` effect'i ANA BİLEŞENDEN ÖNCE koşar (React: çocuk
 * effect'leri önce) ve KENDİ girdisini üstümüze push'lar. O anda `back()`
 * atmak, alt-sheet'in girdisini tüketirdi → alt-sheet daha açılmadan geri
 * tuşu bozulurdu. `ProfileMobile` bunu elle kurulmuş bir `chainToSheet`
 * yoluyla çözüyor ("history.back YOK — entry alt-sheet'e devredilir");
 * burada damga okunarak KENDİLİĞİNDEN türetilir — elle senkron tutulan
 * ikinci bir liste olmaz.
 */
export function adressizKapanistaPopla(
  pushlandi: boolean,
  durum: unknown,
  etiket: string,
): boolean {
  return pushlandi === true && adressizGirdimizTepede(durum, etiket);
}

/**
 * Gelen popstate BİZİM girdimizin tüketilmesi mi?
 *
 * @param pushlandi   Yığında bizim girdimiz duruyor mu.
 * @param acik        Katman şu an açık mı (render sırasında yazılan ref).
 * @param kendiBack   `back()`i biz mi çağırdık (in-UI kapanış dalı).
 *
 * ── ÜÇÜNCÜ ARGÜMAN NİYE VAR (ölçülmüş regresyon riski) ─────────────────────
 * `ProfileView.navigateMainApp` katmanı kapatıp `pushState(hedef)` +
 * **sentetik** `PopStateEvent` yayıyor (ana-app router'ını uyandırmak için).
 * O sentetik pop, React henüz yeniden render etmediği için `acik` HÂLÂ true
 * iken gelir. Yalnız `pushlandi && acik` deseydik o pop'u BİZİM sanıp
 * `stopImmediatePropagation()` ile yutardık → "Klip Analitiğim" / "Engellenenler"
 * satırları hiçbir yere gitmezdi. Bu yüzden çağıran, girdisini bilerek bırakır
 * (`girdiyiBirak`) ve bayrak düşer → bu yüklem `false` döner.
 */
export function adressizPopBizim(
  pushlandi: boolean,
  acik: boolean,
  kendiBack: boolean,
): boolean {
  if (!pushlandi) return false;
  return acik === true || kendiBack === true;
}
